import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

import modules from '@/modules/Vuex'

Vue.use(Vuex)
Vue.config.devtools = true

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: modules,
  strict: true
})



// WEBPACK FOOTER //
// ./src/vuex/index.js